function openChatBot() {
  window.embeddedservice_bootstrap.utilAPI.launchChat()
}

const initChatBotCtaButtons = () => {
  window.addEventListener('onEmbeddedMessagingReady', () => {
    const chatBotCtaElements = document.querySelectorAll('[data-chatbot-cta]')
    for (let i = 0; i < chatBotCtaElements.length; i += 1) {
      chatBotCtaElements[i].addEventListener('click', openChatBot)
    }
  })
}
export default initChatBotCtaButtons
